import React, { Component } from 'react';
import PropTypes from 'prop-types';

import firstWordCapitalized from 'common/util/firstWordCapitalized';

import { DATA_TABLE_SOURCE_ADMIN_TOURS } from 'common/dataTableConstants';
import { SR_API_ACTION_ADD_LISTING_TO_TOUR } from 'api/actionTypes';
import { TOUR_SHOWING_SOURCE_ADMIN_ADD_TO_TOUR } from 'common/tourConstants';

import { dataTable, actionDataTableLoadItems } from 'client/helpers/dataTables';

import withApiState from 'client/helpers/withApiState';
import postWithState from 'client/actions/postWithState';
import MapViewManagerActions from 'client/actions/MapViewManager';

import ButtonDeprecated from 'client/components/ButtonDeprecated';

function getTourTableSettings({ tourId }) {
  return {
    dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
    viewId: `addToTour-${tourId}`,
    count: 1,
    filter: {
      'tours.id': tourId,
    },
  };
}

@dataTable(getTourTableSettings)
@withApiState({
  addToTourApiState: {
    action: SR_API_ACTION_ADD_LISTING_TO_TOUR,
  },
})
class SrListingAddToTourSection extends Component {
  static propTypes = {
    addToTourApiState: PropTypes.object,
    dataTableApiState: PropTypes.object,
    listingId: PropTypes.number.isRequired,
    tourId: PropTypes.number.isRequired,
    items: PropTypes.array,
    dispatch: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { tourId, dispatch } = this.props;

    const tourTableSettings = getTourTableSettings({ tourId });
    dispatch(actionDataTableLoadItems, tourTableSettings);
  }

  _addToTour = () => {
    const { dispatch, listingId, items } = this.props;

    const tourId = items[0].id;
    const userId = items[0].users[0].id;

    dispatch(postWithState, {
      action: SR_API_ACTION_ADD_LISTING_TO_TOUR,
      payload: {
        tourId,
        listingId,
        userId,
        source: TOUR_SHOWING_SOURCE_ADMIN_ADD_TO_TOUR,
      },
    }).then(() => {
      const tourTableSettings = getTourTableSettings({ tourId });
      dispatch(actionDataTableLoadItems, {
        ...tourTableSettings,
        onSuccess: ({ items }) => {
          const tour = items[0];
          dispatch(MapViewManagerActions.setValues, {
            mapViewId: tourId,
            values: { tour },
          });
        },
      });
    });
  };

  render() {
    const { addToTourApiState, dataTableApiState, items, listingId } = this.props;
    const tour = items[0];

    if (!tour) {
      return null;
    }

    const user = tour.user;
    const userFirstName = firstWordCapitalized(user.name);
    const tourListingIds = tour.listings.map(({ id }) => id);
    const isListingInTour = tourListingIds.includes(listingId);
    const buttonDisabled =
      isListingInTour || addToTourApiState.inProgress || dataTableApiState.inProgress;

    return (
      <div className="section titled agentSection">
        <div className="titleContainer">
          <span className="title">{`add to ${userFirstName.toLowerCase()}'s tour`}</span>
        </div>
        <ButtonDeprecated onClick={this._addToTour} disabled={buttonDisabled}>
          {`${isListingInTour ? 'added' : 'add'} to ${userFirstName.toLowerCase()}'s tour`}
        </ButtonDeprecated>
      </div>
    );
  }
}

SrListingAddToTourSection.displayName = 'SrListingAddToTourSection';

export default SrListingAddToTourSection;
